<template>
  <div class="mb-8" v-if="onboarded">
    <h1 class="text-2xl font-medium mb-4">Stripe Connect account management</h1>
    <div class="mt-4">
      <h2 class="text-xl font-medium mb-1">Access your dashboard</h2>
      <button @click="getStripeConnectLink()" type="button" class="g--button  mt-4">
        Go to my Stripe Connect dashboard
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
const onboarded = ref(false);

onMounted(() => {
  const data = {};
  data[csrfTokenName] = csrfTokenValue;

  fetch('/actions/live-yoga-teachers/connect/is-onboarded', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams(data).toString()
  })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(responseData => {
        onboarded.value = responseData.onboarded;
      })
      .catch(error => {
        console.error('Error: ', error);
      });
})
const getStripeConnectLink = () => {
  let data = {};
  data[csrfTokenName] = csrfTokenValue;

  fetch('/actions/live-yoga-teachers/connect/get-dashboard-link', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams(data).toString()
  })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(responseData => {
        if (responseData.url) {
          window.location = responseData.url;
        } else {
          console.log("data", responseData);
        }
      })
      .catch(error => {
        console.error('Error: ', error);
      });
};
</script>